import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Logo } from "assets/images/house_scan_logo.svg";
import { ReactComponent as LogoWhite } from "assets/images/house_scan_logo_white.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import searchPage from "assets/images/search_page.png";
import SpinnerLoading from "components/Loading/SpinnerLoading";
import { motion } from "framer-motion";
import { Pagination } from "swiper/modules";
import { SwiperSlide, Swiper } from "swiper/react";
import useAuth from "hooks/useAuth";
import searchPageImage from "assets/images/3rd.webp";
import adOrganizerPage from "assets/images/4th.webp";

const AuthDialogLayout = ({
  isDialogOpen,
  closeDialog,
  children,
  isCopyrightHide = false,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const dialogRef = useRef(null);
  const spinnerRef = useRef(null);
  const isDragging = useRef(false);
  const { setLoading } = useAuth();

  // Slider settings
  const settings = {
    modules: [Pagination],
    slidesPerView: 1,
    pagination: false,
    onSlideChange: (swiper) => {
      setActiveIndex(swiper.activeIndex);
    },
    // Disable dragging/swiping on desktop and mobile
    simulateTouch: false,
    touchStartPreventDefault: true,
  };

  // Navigate on slider dot click
  const handleDotClick = (index) => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(index); // Navigate to the clicked slide
    }
  };

  const handleMouseDown = () => {
    isDragging.current = true; // User is starting to drag
  };

  const handleMouseUp = (e) => {
    if (
      isDialogOpen &&
      dialogRef.current &&
      !dialogRef.current.contains(e.target) &&
      !spinnerRef.current?.contains(e.target)
    ) {
      // Close if mouse is released outside and not dragging
      if (!isDragging.current) {
        closeDialog();
        setLoading(false);
      }
    }
    isDragging.current = false; // Reset dragging state
  };

  useEffect(() => {
    // Attach mouse up event listener to document
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [isDialogOpen, closeDialog]);

  return (
    <div
      className={`dialog-overlay ${isDialogOpen && "!opacity-100 !visible"} `}
      onMouseDown={(e) => e.stopPropagation()} // Prevent click on overlay
    >
      <motion.div
        ref={dialogRef}
        initial={{ y: 100, opacity: 0 }}
        animate={isDialogOpen ? { y: 0, opacity: 1 } : {}}
        transition={{ duration: 0.5, ease: "linear" }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={handleMouseDown}
        className="max-w-[1335px] overflow-hidden md:h-full lg:w-full custom-shadow absolute w-fit h-auto max-h-[828px] bg-[#F5F5F5] rounded-[15px] "
      >
        <div className="flex items-start justify-between h-full">
          <div className="w-full lg:w-[41.8%] relative h-full">
            <div className="md:w-[360px] mx-auto lg:mt-[52px]">
              <Logo className="w-[206px] hidden lg:block h-[43px]" />
              {/* mobile top bar  */}
              <div className="px-[12px] pt-[13px] lg:hidden pb-[11px] min-w-[319px] md:min-w-full sm:min-w-[500px] h-[149px] w-full">
                <div className="rounded-[13px] h-full w-full relative overflow-hidden">
                  <div className="flex items-center justify-end p-1">
                    {/* <LogoWhite className="w-[115px] object-contain h-[26px]" /> */}
                    <div
                      onClick={closeDialog}
                      className="flex items-center justify-center w-6 h-6 cursor-pointer"
                    >
                      <CloseIcon color="black" fill="black" className="z-[1]" />
                    </div>
                  </div>
                  <img
                    className="absolute -top-[3px] left-0 right-0 bottom-0"
                    src={searchPageImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="lg:px-0 px-[32px] pb-[22.5px]">{children}</div>
            </div>
          </div>

          <div className="hidden lg:block  lg:w-[58.2%] bg-[#262626] relative h-full box-border rounded-tr-[15px] rounded-br-[15px] pt-[65px] pl-[98px]">
            <div
              onClick={closeDialog}
              className="w-[24px] h-[24px] absolute top-3 right-3 z-[1px] flex items-center justify-center cursor-pointer"
            >
              <CloseIcon color="white" fill="white" />
            </div>
            <div className="relative">
              <div className="max-w-[594px]">
                <h1 className="text-[36px] font-semibold text-[#F5F5F5] leading-[43.57px]">
                  Accedi per utilizzare tutte le funzionalità di HouseScan{" "}
                </h1>
                <p className="text-[#F5F5F5] text-[15px] font-normal leading-[18.15px] mt-3">
                  Iscrivendoti gratis avrai accesso alle informazioni avanzate
                  sulla ricerca, una Dashboard per l’analisi, e un Organizer per
                  contenere tutti gli annunci interni ed esterni in un unico
                  posto!
                </p>
              </div>
              {/* Custom slider dots  */}
              <div className="slider__controls flex items-center mt-[31px] mb-[47px]">
                {/* <div className="slider__pagination">
                  {[0, 1].map((_, index) => (
                    <div
                      key={index}
                      onClick={() => handleDotClick(index)}
                      className={`swiper-pagination-bullet ${
                        index === 0 ? "ml-0" : "ml-[9px]"
                      } ${
                        activeIndex === index
                          ? "swiper-pagination-bullet-active"
                          : ""
                      }`}
                    />
                  ))}
                </div> */}
              </div>

              <div className="w-full h-full  max-h-[520px]">
                <Swiper {...settings} ref={swiperRef}>
                  <SwiperSlide>
                    <div className="">
                      <img
                        src={searchPage}
                        alt="dashboard"
                        className="w-full h-full object-cover object-left-top"
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="">
                      <img
                        src={adOrganizerPage}
                        alt="dashboard"
                        className="w-full h-full object-cover object-left-top"
                      />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        {!isCopyrightHide && (
          <div className="absolute hidden md:block w-full lg:w-[41.8%] bottom-[28.75px] mx-auto">
            <p className="text-center text-[#666666] text-[12px] font-normal leading-4 tracking-[-0.4px]">
              © Copyrights {new Date().getFullYear()}
            </p>
          </div>
        )}
      </motion.div>

      <SpinnerLoading spinnerRef={spinnerRef} />
    </div>
  );
};

export default AuthDialogLayout;
